export default __webpack_public_path__ + "static/sprite-gui-3621a161b59bcbf2a3d420f073a59bc6.png";